import { getDocumentFormat, getIdDocumentType } from "../libs/helpers/util";

export class CreateCustomerCrmOracle {
    constructor({
        names = null,
        surname = null,
        secondLastName = null,
        documentType = null,
        numDocument = null,
        cellphone = null,
        email = null,
    } = {}) {
        this.FirstName = names;
        this.LastName = surname;
        this.SecondLastName = secondLastName;
        this.PersonDEO_chTipoDoc_c = getIdDocumentType(documentType);
        this.PersonDEO_tNumDoc_c = getDocumentFormat(numDocument, documentType);
        this.PersonDEO_cbConsentimiento_c = "N";
        this.ContactPoint = [
            {
                ContactPointType: "PHONE",
                PrimaryFlag: "N",
                PhoneNumber: cellphone,
                PhoneCountryCode: "51",
            },
            {
                ContactPointType: "EMAIL",
                EmailAddress: email,
            },
        ];
    }
}
